import React from 'react';
import type { TabsAlignment } from 'wix-ui-tpa/cssVars';
import { Tabs, TabsSkin, Dropdown, DropdownTheme } from 'wix-ui-tpa/cssVars';
import { useNavigationLogic } from './Navigation.logic';
import type { PopulatedMenu } from 'root/apiTypes';
import type { NavigateToFn } from 'root/clientTypes';
import { MenuListNavigation, NavigationDropdownStyle } from 'root/consts';
import { classes } from './Navigation.st.css';
import { dataHooks } from 'root/dataHooks';
import type { ILocation } from '@wix/yoshi-flow-editor';

export const Navigation = ({
  activeItem,
  setActiveItem,
  menus,
  navigateTo,
  currentUrl,
  isRow,
}: {
  activeItem: number;
  setActiveItem: (index: number) => void;
  menus: PopulatedMenu[];
  navigateTo: NavigateToFn;
  currentUrl: ILocation['url'];
  isRow?: boolean;
}) => {
  const {
    navigationLayout,
    tabsWidth,
    dropdownOptions,
    tabOptions,
    onClickNavigationDropdownOption,
    onClickTab,
    navigationDropdownStyle,
    renderButHideTabsForSeo,
    overflowBehavior,
    navigationTextAlignment,
    isDropdown,
    t,
  } = useNavigationLogic({
    menus,
    setActiveItem,
    navigateTo,
    currentUrl,
    isRow,
  });

  return (
    <div
      className={`${classes.container} ${!isDropdown && classes.tabsContainer}`}
      data-hook={dataHooks.navigation.container}
    >
      <Tabs
        activeTabIndex={activeItem}
        alignment={navigationTextAlignment as TabsAlignment}
        aria-label="Menus"
        className={`${classes.tabs} ${renderButHideTabsForSeo && classes.hidden}`}
        data-hook={dataHooks.navigation.tabs}
        items={tabOptions}
        overflowBehavior={overflowBehavior}
        skin={TabsSkin.fitUnderline}
        variant={tabsWidth}
        onTabClick={onClickTab}
      />
      {navigationLayout === MenuListNavigation.Dropdown && (
        <div className={classes.dropdownContainer}>
          <div className={classes.dropdownLayout}>
            <Dropdown
              aria-label={t('component.menu.multi-menu.aria-label')}
              className={classes.dropdown}
              data-hook={dataHooks.navigation.dropdown}
              flip={false}
              initialSelectedId={activeItem.toString()}
              options={dropdownOptions}
              placement="bottom"
              theme={navigationDropdownStyle === NavigationDropdownStyle.Box ? DropdownTheme.Box : DropdownTheme.Line}
              onChange={onClickNavigationDropdownOption}
            />
          </div>
        </div>
      )}
    </div>
  );
};
